<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	data() {
		return {
			resizeTimer: null,
			isRedirecting: false
		}
	},
	created() {
		this.$apimit.set(this.$getter("UserCheck"), {});
		this.getSetting();
		this.checkDeviceAndRedirect();
	},
	mounted() {
		window.addEventListener('resize', this.handleResize);
		document.addEventListener('visibilitychange', this.handleVisibilityChange);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
		document.removeEventListener('visibilitychange', this.handleVisibilityChange);
		clearTimeout(this.resizeTimer);
	},
	methods: {
		getSetting() {
			this.$get('sys-setting/1').then(res => {
				this.$vuex('setting', res.data, true);
			}).catch(err => {
				this.$warning(err);
			})
		},
		
		// 生成H5 URL：域名 + /h5，后面不要有任何路径
		generateH5Url() {
			const currentUrl = window.location.href;
			
			try {
				// 使用URL对象解析当前URL
				const url = new URL(currentUrl);
				
				// 构建H5 URL：协议 + 域名 + 端口 + /h5
				let h5Url = `${url.protocol}//${url.hostname}`;
				
				// 添加端口（如果有且不是默认端口）
				if (url.port && url.port !== '80' && url.port !== '443') {
					h5Url += `:${url.port}`;
				}
				
				// 只添加/h5，不要其他路径
				h5Url += '/h5';
				
				return h5Url;
				
			} catch (e) {
				// 如果URL解析失败，使用正则提取基础URL
				const match = currentUrl.match(/^(https?:\/\/[^\/]+)/);
				if (match) {
					const baseUrl = match[1];
					return baseUrl + '/h5';
				}
				
				// 最后兜底方案
				return currentUrl.replace(/(https?:\/\/[^\/]+).*/, '$1/h5');
			}
		},
		
		// 设备判断并跳转
		checkDeviceAndRedirect() {
			if (this.isRedirecting) return;
			
			const ua = navigator.userAgent.toLowerCase();
			const screenWidth = window.innerWidth;
			
			// 移动设备检测
			const isMobile = /iphone|ipod|android.*mobile|windows phone|blackberry|webos|micromessenger.*mobile/i.test(ua) || screenWidth <= 768;
			
			// 生成H5 URL
			const h5Url = this.generateH5Url();
			const currentUrl = window.location.href;
			
			// 如果是移动设备或屏幕宽度小于等于768px
			if (isMobile && screenWidth <= 768) {
				// 避免重复跳转（检查URL是否包含/h5且后面没有路径）
				const isAlreadyH5 = currentUrl.includes('/h5') && 
					(currentUrl.endsWith('/h5') || 
					 currentUrl.match(/\/h5[\/?#]/) === null);
				
				if (!isAlreadyH5 && currentUrl !== h5Url) {
					this.isRedirecting = true;
					window.location.href = h5Url;
				}
			}
		},
		
		// 简化的窗口变化处理
		handleResize() {
			clearTimeout(this.resizeTimer);
			this.resizeTimer = setTimeout(() => {
				this.checkDeviceAndRedirect();
			}, 300);
		},
		
		// 处理微信浏览器页面显示/隐藏事件
		handleVisibilityChange() {
			if (!document.hidden) {
				setTimeout(() => {
					this.checkDeviceAndRedirect();
				}, 500);
			}
		}
	},
};
</script>